














import Vue from 'vue';

export default Vue.extend({
  name: `ChristmasCircle`,
  props: {
    doorNumber: {
      required: true,
      type: Number,
    },
    fake: {
      default: false,
      type: Boolean,
    },
  },
  methods: {
    circleSelected(): void {
      this.$emit(`click:circle`, this.doorNumber);
    },
  },
});
